<template>
  <div class="sixview">
    <div class="selectview">
      <el-row>
        <el-col :span="21">
          <ul class="ullist">
            <li class="liwidth_select">
              <el-select
                v-model="province_value"
                clearable
                placeholder="请选择省份"
                @change="getcitys(province_value)"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.province"
                  :label="item.province"
                  :value="item.province"
                ></el-option>
              </el-select>
            </li>
            <li class="liwidth_select">
              <el-select
                v-model="city_value"
                clearable
                placeholder="请选择城市"
                @change="getStations(city_value)"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.city"
                  :label="item.city"
                  :value="item.city"
                ></el-option>
              </el-select>
            </li>
            <li>
              <el-select
                v-model="station_value"
                clearable
                placeholder="请选择场站"
                @change="getchargers(station_value)"
              >
                <el-option
                  v-for="item in stationList"
                  :key="item.station_id"
                  :label="item.station_name"
                  :value="item.station_id"
                ></el-option>
              </el-select>
            </li>
            <li style="width: 150px">
              <el-select
                v-model="type_value"
                clearable
                placeholder="请选择类别"
              >
                <el-option
                  v-for="item in typelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
            <li style="width: 150px">
              <el-select
                v-model="grade_value"
                clearable
                placeholder="请选择告警等级"
              >
                <el-option
                  v-for="item in gradelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
            <li class="liwidth_date">
              <el-date-picker
                v-model="value_date"
                type="date"
                placeholder="年/月/日"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </li>
            <div style="clear: both"></div>
          </ul>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" class="querybutton" @click="searchClick()"
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="tabelview">
      <el-table
        v-loading.fullscreen.lock="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        element-loading-text="拼命加载中......"
        :data="tableData"
        border
        :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        style="width: 100%"
      >
        <el-table-column
          align="left"
          prop="id"
          label="ID"
          width="80"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="alarm_type"
          label="告警编号"
          width="100"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="alarm_name"
          label="告警名称"
          width="180"
        ></el-table-column>
        <el-table-column align="left" prop="event_severity" label="告警等级">
          <template slot-scope="scope">
            <span style="color: #e60000" v-if="scope.row.event_severity == '1'"
              >高</span
            >
            <span
              style="color: #0061ae"
              v-else-if="scope.row.event_severity == '2'"
              >中</span
            >
            <span
              style="color: #009a5b"
              v-else-if="scope.row.event_severity == '3'"
              >低</span
            >
          </template>
        </el-table-column>
        <el-table-column align="left" prop="category" label="分类" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.category == '1'">边缘主机</span>
            <span v-else-if="scope.row.category == '2'">充电桩</span>
            <span v-else-if="scope.row.category == '3'">地锁</span>
            <span v-else-if="scope.row.category == '4'">电表</span>
            <span v-else-if="scope.row.category == '5'">物联网通信</span>
            <span v-else-if="scope.row.category == '6'">视频监控</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="station_name"
          label="场站名称"
          width="230"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="edge_id"
          label="边缘主机编号"
          width="190"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="device_id"
          label="设备编号"
          width="190"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.device_id == ''">--</span>
            <span v-else>{{ scope.row.device_id }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="device_tn" label="测量点">
          <template slot-scope="scope">
            <span v-if="scope.row.device_tn == '0'">设备主体</span>
            <span v-else-if="scope.row.device_tn == '1'">枪1</span>
            <span v-else-if="scope.row.device_tn == '2'">枪2</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="start_time"
          label="事件发生时间"
          width="160"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="receive_time"
          label="收到事件时间"
          width="160"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="end_time"
          label="事件结束时间"
          width="160"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="event_data"
          label="事件内容"
          width="180"
        ></el-table-column>
        <el-table-column align="left" prop="status" label="事件状态">
          <template slot-scope="scope">
            <span style="color: #009a5b" v-if="scope.row.status == '0'"
              >告警恢复</span
            >
            <span style="color: #e60000" v-else-if="scope.row.status == '1'"
              >发生故障</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="cutpagesview">
      <el-pagination
        class="pageinclass"
        background
        :page-size="pagesize"
        :page-count="pagecount"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next,jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { fail } from "assert";
export default {
  data() {
    return {
      loading: true,
      total: 10, //这个是总共有多少条数据
      pagesize: 20, //每页显示条目个数
      currentPage: 1, //当前页数
      pagecount: 10, //页码按钮的数量

      province_value: "", //选择省份
      provinceList: [], //省份列表
      cityList: [], //城市列表
      city_value: "", //选择城市
      stationList: [], //场站列表
      station_value: "", //选择场站
      value_date: "", //日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

      type_value: "",
      typelist: [
        {
          value: 1,
          label: "边缘主机",
        },
        {
          value: 2,
          label: "充电桩",
        },
        {
          value: 3,
          label: "地锁",
        },
        {
          value: 4,
          label: "电表",
        },
        {
          value: 5,
          label: "物联网通信",
        },
        {
          value: 6,
          label: "视频监控",
        },
      ],
      grade_value: "",
      gradelist: [
        {
          value: 1,
          label: "高",
        },
        {
          value: 2,
          label: "中",
        },
        {
          value: 3,
          label: "低",
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    this.getprovinces();

    var d = new Date();

    let value_date =
      d.getFullYear() +
      "-" +
      this.checkTime(d.getMonth() + 1) +
      "-" +
      this.checkTime(d.getDate());
    this.value_date = value_date;

    this.province_value = this.$store.state.provinceValue;
    this.city_value = this.$store.state.cityValue;
    this.getStations1(this.city_value);
    this.querybtnClick();
  },
  methods: {
    /**
     * 获取省份数据列表
     */
    getprovinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };

      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            // console.log("省份列表--：", su.data.list);
            this.provinceList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    /**
     * 获取城市列表
     */
    getcitys(province_value) {
      this.city_value = "";
      this.cityList = [];
      this.station_value = "";
      this.$store.commit("CityValue", "");
      this.$store.commit("StationValue", "");
      this.$store.commit("ProvinceValue", province_value);

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province_value,
      };

      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            //  console.log("市列表--：",su.data.list)
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.$message.warning("没有选择省份");
          }
        })
        .catch((err) => {});
    },

    /**
     * 获取场站列表
     */
    getStations(city_value) {
      //    console.log(this.cityList)
      this.station_value = "";
      this.stationList = [];
      this.$store.commit("CityValue", city_value);
      this.$store.commit("StationValue", "");

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city_value,
      };
      //   console.log("场站列表传值---：",params,)
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
            // console.log("场站信息--：", this.stationList);
          } else if (su.data.code == 0) {
            //数据库操作失败
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.$message.warning("没有选择城市");
          }
        })
        .catch((err) => {});
    },

    getStations1(city_value) {
      var that = this;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city_value,
      };
      //   console.log("场站列表传值---：",params,)
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            su.data.list.map((item) => {
              if (this.$store.state.stationValue == item.station_id) {
                this.station_value = item.station_name;
              }
            });
          }
        })
        .catch((err) => {});
    },

    getchargers(station_value) {
      this.$store.commit("StationValue", station_value);
    },

    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      var value = String(val);
      this.querybtnClick(value);
    },
    /**
     * 筛选硬件告警日志
     */
    querybtnClick(page) {
      // this.tableData = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getHardwareAlarmLogs",
         station_id:this.$store.state.stationValue
      };
      if (page != "" && page != null) {
        params.page = page;
      }
      if (this.province_value != "") {
        params.province = this.province_value;
      }
      if (this.city_value != "") {
        params.city = this.city_value;
      }
      // if (this.station_value != "") {
      //   params.station_id = this.station_value;
      // }

      if (this.type_value != "") {
        params.category = this.type_value;
      }
      if (this.grade_value != "") {
        params.event_severity = this.grade_value;
      }
      if (this.value_date != "" && this.value_date != null) {
        var d = new Date(this.value_date);
        // console.log("开始时间--：",d)
        let value_date =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate());
        params.date = value_date;

        //最后显示yyyy-MM-dd
      }

      // console.log("硬件日志筛选传参--：", params);
      this.$api({
        method: "post",
        url: "/api.php/AlarmManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // console.log("硬件日志su--：", su);
          if (su.data.code == 1) {
            let datalist = su.data.list;
            // this.total = datalist.length;
            // this.pagecount = parseInt(datalist.length / 8 + 1);
            this.tableData = datalist;
            if (su.data.count == "" || su.data.count == null) {
            } else {
              this.total = su.data.count;
              this.currentPage = 1;
              // this.pagecount = su.data.count / 20;
              if (su.data.count % 20 == 0) {
                this.pagecount = parseInt(su.data.count / 20);
              } else {
                this.pagecount = parseInt(su.data.count / 20 + 1);
              }
            }
            this.loading = false;
          } else if (su.data.code == 300) {
            //登陆过期
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 0) {
            this.total = 0;
            this.pagecount = 1;
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.total = 0;
            this.pagecount = 1;
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    searchClick() {
      this.loading = true;
      this.total = 10;
      this.pagesize = 20;
      this.currentPage = 1;
      this.pagecount = 10;
      this.querybtnClick();
    },
  },
};
</script>
<style scoped lang="scss">
.sixview {
  padding: 1%;
  background-color: white;
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #0071bd;
    border-color: #0071bd;
    color: #fff;
  }
}
.ullist {
  list-style-type: none;
  padding: 0;
  li {
    float: left;
    // display: inline-block;
    margin: 5px 5px 5px 0px;
  }
}
.liwidth_select {
  width: 120px;
}
.liwidth_input {
  width: 180px;
}
.liwidth_date {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 150px !important;
  }
}

.tabelview {
  margin-top: 15px;
  margin-bottom: 15px;
}

.querybutton {
  width: 80px;
  margin-left: 15px;
  margin: 5px 5px 5px 0px;
  text-align: center;
  display: inline-block;
  background-color: #0071bd;
  color: white;
  border: none;
}
.sixview {
  .querybutton:active {
    background-color: #409EFF;
  }
}
.cutpagesview {
  margin: 20px 0;
  height: 30px;
}
.pageinclass {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/operationManagement/hardwareLog.vue